import React, { Component } from 'react';
import { ValidationType } from '../../Constants/ValidationTypes';
import * as v from '../HelperComponents/Validators';

type Props = {
    value: string,
    label: string,
    onChange?: (value: string) => void,
    validation?: boolean,
    validationType?: ValidationType,
    regex?: RegExp,
    errorBodyText?: string,
    errorExampleText?: string,
    onEnterPressed?: () => void,
    setValid?: (valid: boolean) => void,
    buttonClicked?: Boolean,
    onValidatingButtonPressed?: () => void
    width?: string,
    readonly?: boolean,
    direction?: "row" | "column",
    type?: string,
};

type State = {
    showError: Boolean,
    isValid: Boolean,

}


export class FstyrInput extends Component<Props, State>  {

    hasBeenValid = false;
    id = this.getRandomId();


    constructor(props: Props) {
        super(props);
        this.state = {
            showError: false,
            isValid: false,
        };
    }

    //This is used to combat DesignSystemets label for functionality
    getRandomId() {
        //credit
        //https://stackoverflow.com/questions/6860853/generate-random-string-for-div-id
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    }

    checkShowError() {
        if ((this.props.buttonClicked || this.hasBeenValid) && !this.state.showError && !this.state.isValid) {
            this.setState({ showError: true });
        }
    }

    onChange(value: string) {
        if (this.props.onChange) this.props.onChange(value);
        if (this.props.validation) {
            if (this.validate(this.props.validationType, value)) {
                this.setState({
                    isValid: true,
                    showError: false
                }, () => this.checkShowError());
                if (this.props.setValid) { this.props.setValid(true) }
                this.hasBeenValid = true;
            } else {
                this.setState({ isValid: false }, () => this.checkShowError());
                if (this.props.setValid) { this.props.setValid(false) }
            }
        }
    }

    onBlur() {
        if (!this.state.isValid) {
            this.setState({ showError: true });
        } else {
            this.setState({ showError: false });
        }
    }

    componentDidMount() {
        if (this.props.validation && this.props.value && this.props.value.toString().length > 0) {
            if (this.validate(this.props.validationType, this.props.value)) {
                this.setState({
                    isValid: true,
                    showError: false
                });
                if (this.props.setValid) { this.props.setValid(true) }
                this.hasBeenValid = true;
            }
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.buttonClicked && !prevProps.buttonClicked) {
            this.onChange(this.props.value)
        }
        if (this.props.onChange && prevProps.value !== this.props.value) {
            this.onChange(this.props.value)
            if (this.props.validationType === ValidationType.cpr) {
                this.onChange(this.props.value.replace(/[^0-9]/gi, ''))
            }
            else if (this.props.validationType === ValidationType.cardNumber) {
                this.onChange(this.props.value.replace("DKDK", 'DK').replace(/[^0-9A-Z]/gi, ''))
            }
        }
        if(this.props.regex?.toString() !== prevProps.regex?.toString()){
            this.onChange(this.props.value)
        }
    }

    validate(type: ValidationType | undefined, value : string) {
        switch (type) {
            case ValidationType.cardNumber:
                return v.ValidateCardNumber(value);
            case ValidationType.regex:
                if (!this.props.regex) {
                    return false;
                }
                return v.ValidateCustomRegex(value, this.props.regex);
            case ValidationType.cpr:
                return v.ValidateCpr(value);
            case ValidationType.cvr:
                return v.ValidateCvr(value);
            case ValidationType.driverLicenseDk:
                return v.ValidateDriverLicenseDk(value);
            case ValidationType.driverLicenseInt:
                return v.ValidateDriverLicenseInt(value);
            case ValidationType.textNoSpaces:
                return v.ValidateTextNoSpaces(value);
            case ValidationType.textWithSpaces:
                return v.ValidateTextWithSpaces(value);
            case ValidationType.textWithSpacesAndNumbers:
                return v.ValidateTextWithSpacesAndNumbers(value);
            case ValidationType.commaSeparatedList:
                return v.ValidateCommaSeparatedList(value);
            case ValidationType.autorisationsNr:
                return v.ValidateAutorisationsNr(value);
            case ValidationType.amountOfCards:
                return v.ValidateAmountOfCards(value);
            case ValidationType.textWithSpacesMax35:
                return v.ValidateTextWithSpacesMax35(value);
            case ValidationType.textWithSpacesAndNumbersMax35:
                return v.ValidateTextWithSpacesAndNumbersMax35(value);
            case ValidationType.wrxNr:
                return v.ValidateWrxNr(value);
            default:
                return false
        }
    }

    handleKeyPress(e : React.KeyboardEvent<Element>) {
        if (e.key === "Enter" && this.props.onEnterPressed) {
            this.props.onEnterPressed()
        }
    }


    render() {
        return (
            <div className={this.state.showError && this.props.validation ? "form-group form-error" : ""}>
                <div className={this.props.direction === "row" ? "fstyr-align-row" : "fstyr-align-column"}>
                    <label className="form-label" htmlFor={this.id}>
                        {this.props.label}
                    </label>
                    <input className="form-input" required
                        style={{ overflow: "auto", width: this.props.width ?? "" }}
                        id={this.id}
                        value={this.props.value}
                        readOnly={this.props.readonly ?? false}
                        name={this.id}
                        type={this.props.readonly ? "textarea" : this.props.type ?? "text"}
                        onChange={(e) => this.onChange(e.target.value)}
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        onBlur={() => this.onBlur()}
                    />
                </div>
                {this.props.errorExampleText && this.state.showError && this.props.validation &&
                    <span className="form-hint" id="form-error-hint">
                        {this.props.errorExampleText}
                    </span>
                }
                {this.props.errorBodyText && this.state.showError && this.props.validation &&
                    <span className="form-error-message" id="form-error-error">
                        {this.props.errorBodyText}
                    </span>
                }
            </div>
        )
    }
}
